import React from 'react'

import {
  CommonBookmarkActiveIcon,
  CommonLike1Icon,
  ToastAlarmIcon,
  ToastCheckIcon,
  ToastErrorIcon,
  ToastWarnIcon,
} from '@local/assets/icons'

import styles from './index.module.scss'

const iconMap = {
  bookmark: { Icon: CommonBookmarkActiveIcon, className: 'icon_bookmark' },
  like: { Icon: CommonLike1Icon, className: 'icon_likeit' },
  error: { Icon: ToastErrorIcon, className: 'icon' },
  warn: { Icon: ToastWarnIcon, className: 'icon' },
  alarm: { Icon: ToastAlarmIcon, className: 'icon' },
  check: { Icon: ToastCheckIcon, className: 'icon' }, // 아직 케이스 없음
} as const

export type ToastIconType = keyof typeof iconMap

interface Props {
  type?: ToastIconType
}

const ToastIcon = ({ type }: Props) => {
  if (!type) return null

  if (!iconMap[type]) return null

  const { Icon, className } = iconMap[type]

  return (
    <span className={styles.icon_wrapper}>
      <Icon className={styles[className]} aria-hidden="true" />
    </span>
  )
}

export default ToastIcon
